module.exports = {"621023100":"悦乐镇","621023101":"柔远镇","621023102":"元城镇","621023103":"南梁镇","621023104":"城壕镇","621023105":"五蛟镇","621023202":"上里塬乡","621023203":"王咀子乡","621023204":"白马乡","621023205":"怀安乡","621023206":"乔川乡","621023207":"乔河乡","621023208":"山庄乡","621023210":"林镇乡","621023211":"紫坊畔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621023.json
// module id = 2729
// module chunks = 0